/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SetUserDeletePayloadModel model module.
 * @module model/SetUserDeletePayloadModel
 * @version v1.0.0
 */
class SetUserDeletePayloadModel {
    /**
     * Constructs a new <code>SetUserDeletePayloadModel</code>.
     * @alias module:model/SetUserDeletePayloadModel
     * @param _delete {Boolean} delete status (required)
     * @param userId {String} user id (required)
     */
    constructor(_delete, userId) { 
        
        SetUserDeletePayloadModel.initialize(this, _delete, userId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, _delete, userId) { 
        obj['delete'] = _delete;
        obj['userId'] = userId;
    }

    /**
     * Constructs a <code>SetUserDeletePayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SetUserDeletePayloadModel} obj Optional instance to populate.
     * @return {module:model/SetUserDeletePayloadModel} The populated <code>SetUserDeletePayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SetUserDeletePayloadModel();

            if (data.hasOwnProperty('delete')) {
                obj['delete'] = ApiClient.convertToType(data['delete'], 'Boolean');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
        }
        return obj;
    }


}

/**
 * delete status (required)
 * @member {Boolean} delete
 */
SetUserDeletePayloadModel.prototype['delete'] = undefined;

/**
 * user id (required)
 * @member {String} userId
 */
SetUserDeletePayloadModel.prototype['userId'] = undefined;






export default SetUserDeletePayloadModel;

